module.exports = __webpack_public_path__ + "static/media/student talent.afee7278.svg";